/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-08-04 10:55:30
 */
import React, { useState, useEffect} from "react";
import { InputNumber, Table, message, Input, Select, Upload, Image } from 'antd';
import type { TableColumnsType, TableProps, UploadFile, UploadProps, GetProp } from 'antd';
import { setApplyCount } from '@/features/user/userSlice';
import { useParams, useNavigate } from "react-router-dom";
import { getOrderById, orderCountTotal } from '@/api/personal-center';
import { getReasonList, applyAfterSales, deleteUploadImg } from '@/api/after-sales';
import { openCustomerService} from '@/utils/index';
import { dispatch } from '@/redux/store';
import { DataType, reasonType } from '../type';
import humanImg from './img/cus-img.png';
import uploadImg from './img/upload.png';
import {getBuyWay} from '@/utils'
import './index.scss';

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
const OrderDetail: React.FC = () => {
  const { TextArea } = Input;
  const param = useParams();
  const navigate = useNavigate();
  const [orderInfo, setOrderInfo] = useState<any>({});
  const [merchBillList, setMerchBillList] = useState<DataType[]>([]);
  const [reasonType, setReasonType] = useState(-1); // 提交原因选择
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [reasonList, setReasonList] = useState<reasonType[]>([]); // 原因
  const [reasonText, setReasonText] = useState(''); // 问题描述
  const [selectRowList, setSelectRowList] = useState<DataType[]>([]); // 勾选商品
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const merchBillColumns: TableColumnsType<DataType> = [
    {
    title: '订单商品',
    dataIndex: 'productName',
    width: 540,
    render: (text: string, record: DataType) => (
      <div className="product-select">
        <div className="name-show" onClick={()=>window.open(`/detail?productSn=${record.productSn}`)} title={text+' '+(record.models.find((ele:any)=>ele?.type===1))?.models}>
          <img src={record.pmsFiles[0]?.url} alt="" />
          {text}<span>
          {
            record.models.length > 0 &&
            <>
            {(record.models.find((ele:any)=>ele?.type===1))?.models} {record.models.find((ele:any)=>ele?.feeType==='2')&&getBuyWay((record.models.find((ele:any)=>ele?.type===1))?.subscribe[0]?.unit)}
            </>
          }
          </span>
        </div>
        
      </div>
    ),
  },
    {
      title: '单价',
      dataIndex: 'productPrice',
    },
    {
      title: '购买数量',
      dataIndex: 'productQuantity',
    },
    {
      title: '售后数量',
      dataIndex: 'afterTotal',
      render:(text: number, record: DataType) => (
        <InputNumber onChange={(value)=>proCountChange(value,record.id)} min={1} max={record.productQuantity} value={record.afterTotal} className="pro-count" />
      )
    },
  ];
  useEffect(() => {
    applyReasonFunc();
  },[])
  useEffect(() => {
    orderDetailFunc();
  },[param.id])

  // 售后数量改变
  const proCountChange = (value:number|null,ids:number) => {
    if(value) {
      const getBillList = merchBillList.map((mRes:any) => {
        if(mRes.id === ids) {
          mRes.afterTotal = value;
        }
        return mRes;
      })
      setMerchBillList(getBillList);
    }
  }

  // 获取售后原因列表
  const applyReasonFunc = () => {
    const reasonArr:any= [];
    getReasonList().then((gRes:any) => {
      if(gRes.success) {
        gRes.obj.forEach((ele:reasonType) => {
          reasonArr.push({
            value: ele.id,
            label: ele.name
          })
        })
        setReasonList(reasonArr);
      }
    })
  }
  // 订单详情
  const orderDetailFunc = () => {
    getOrderById({id: param.id}).then((gRes:any) => {
      if(gRes.success) {
        const getObj = gRes.obj;
        const getRes = gRes.obj?.productList.map((cRes: any) => {
          cRes.key = cRes.id;
          cRes.afterTotal = cRes.productQuantity;
          return cRes;
        });
        setOrderInfo(getObj);
        setMerchBillList(getRes);
      }
    })
  }
  // 提交原因选择
  const reasonSelectFunc = (value:number) => {
    setReasonType(value);
  }
  // 问题描述
  const describeChange = (e:any) => {
    setReasonText(e.target.value);
  }
  // 提交申请
  const applySubmit = () => {
    if(selectRowList.length <= 0) {
      message.warning('请选择售后商品及售后数量');
      return
    }
    if(reasonType === -1) {
      message.warning('请选择提交原因');
      return
    }
    if(reasonText === '') {
      message.warning('请输入问题描述');
      return
    }
    const getProduct:any = [];
    let isSubmit = true;
    selectRowList.forEach((ele:any) => {
      if(ele.afterTotal === null || ele.afterTotal <= 0) {
        isSubmit = false;
      }
      getProduct.push({
        productId: ele.id,
        productSn: ele.productSn,
        quantity: ele.productQuantity,
        applyQuantity: ele.afterTotal,
        productName: ele.productName,
        relates: ele.models.map((item:any) => item.id)
      })
    });
    if(!isSubmit) {
      message.warning('请选择售后商品及售后数量');
      return
    }
    const params = {
      orderId: param.id,
      orderNo: orderInfo.orderNo,
      reasonId: reasonType,
      description: reasonText,
      reasonPic: fileList.map((ele:any) => ele.id),
      products: getProduct
    }
    applyAfterSales(params).then((sRes:any) => {
      if(sRes.success) {
        message.success('提交成功！');
        navigate('/user/as/List');
        cartCountFunc();
      }else {
        message.error(sRes.message);
      }
    })
  }
  const cartCountFunc = () => {
    orderCountTotal().then((oRes:any) => {
      if(oRes.success) {
        dispatch(setApplyCount(oRes.obj?.apply??0));
      }
    })
  }
  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button" className="upload-btn">
      <img src={uploadImg} alt='' />
      <div >图片上传</div>
    </button>
  );
  const handleChange: UploadProps['onChange'] = (info: any) => {
    if(info.file.status === 'removed') {
      const newFile = fileList.filter((ele:any)=> ele.id !== info.file.id);
      setFileList(newFile);
      deleteUploadImg([info.file.id]);
    }
  }
  const rowSelection: TableProps<DataType>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setSelectRowList(selectedRows);
    },
  };
  const customUpload = async (options: any) => {
    const { file } = options;
    const lastIndex = file.name.lastIndexOf("."); // 找到最后一个","的位置
    const upType = file.name.substring(lastIndex + 1);
    if (file.size > 5 * 1024 * 1024 || !['png','jpeg','jpg'].includes(upType) || fileList.length>=5) {
      message.error('请上传不超过5张图片；每张图片大小不超过5M，图片支持jpg、png、jpeg格式');
      return Upload.LIST_IGNORE;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('foldName','apply');
    try {
      fetch('/product/file/upload', {
        method: 'POST',
        body: formData,
      }).then(res => res.json())
      .then((res) => {
        if(res.success) {
          message.success('上传成功');
          setFileList([...fileList,res.obj]);
        }
      })

    } catch (error) {
     console.log('error:',error);
    }
  };
  const getBase64 = (file: FileType): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  // 预览
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };
  return (
    <div className="apply-service-main">
      <div className="order-head">
        申请售后
        <span className="after-number">订单号：{orderInfo.orderNo}</span>
        <div className="human-service" onClick={()=>openCustomerService()}>
          <img src={humanImg} alt='' />
          <span>人工客服</span>
        </div>
      </div>
      <div className="order-detail-content">
        <h1><i>*</i>选择售后商品</h1>
        <Table<DataType> 
          rowSelection={{ ...rowSelection }} 
          columns={merchBillColumns} 
          dataSource={merchBillList} 
          pagination={false} 
        />
        <h1><i>*</i>提交原因</h1>
        <Select 
          placeholder='请选择提交原因'
          options={reasonList}
          onChange={reasonSelectFunc}
          getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
        />
        <h1><i>*</i>问题描述</h1>
        <TextArea className="describe-input" placeholder="请输入问题描述，不超过500字" maxLength={500} onChange={describeChange} />
        <h1>图片附件</h1>
        <Upload
          accept='.png,.jpg,.jpeg'
          action=""
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          onChange={handleChange}
          customRequest={customUpload}
        >
          {fileList.length >= 5 ? null : uploadButton}
        </Upload>
        {previewImage && (
          <Image
            wrapperStyle={{ display: 'none' }}
            preview={{
              visible: previewOpen,
              onVisibleChange: (visible) => setPreviewOpen(visible),
              afterOpenChange: (visible) => !visible && setPreviewImage(''),
            }}
            src={previewImage}
          />
        )}
        <p>为了帮助您更好的解决问题，请上传不超过5张图片；每张图片大小不超过5M，图片支持jpg、png、jpeg格式</p>
        <div className="apply-bottom">
          <span onClick={()=>applySubmit()}>提交申请</span>
          <p>*温馨提示：售后处理可能不再返还您的优惠券，请您申请售后前联系<mark onClick={()=>openCustomerService()}>【人工客服】</mark>咨询</p>
        </div>
      </div>
    </div>
  )
}

export default OrderDetail;